import * as React from 'react';
import Text, { OptionalProps as TextProps } from 'components/Text';

import cx from 'classnames';

import './styles/StatusLabel.scss';

type Props = {
  className?: string;
} & TextProps;

class StatusLabel extends React.Component<Props> {
  render() {
    return (
      <Text {...this.props} className={cx('StatusLabel', this.props.className)} color="graphite">
        {this.props.children}
      </Text>
    );
  }
}

export default StatusLabel;
